class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // Zavírací tlačítka existující při startu (overlay, X, pokračovat) —
    // stepper a karty se vkládají později přes innerHTML, ty sem nespadnou.
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.addEventListener('click', this.onQuantityClick.bind(this));

    this.scrollEl = this.notification.querySelector('.cart-modal__scroll');
    if (this.scrollEl) {
      this.scrollEl.addEventListener('scroll', () => this.scheduleScrollFades(), { passive: true });
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    // Modal se ukazuje přepnutím display (animuje keyframes, ne transition),
    // takže fokus až po aplikování layoutu místo čekání na transitionend.
    requestAnimationFrame(() => {
      this.notification.focus();
      trapFocus(this.notification);
    });
    this.scheduleScrollFades();
    window.setTimeout(() => this.scheduleScrollFades(), 350);

    document.body.addEventListener('click', this.onBodyClick);
  }

  scheduleScrollFades() {
    if (this.fadeFrame) return;
    this.fadeFrame = requestAnimationFrame(() => {
      this.fadeFrame = null;
      this.updateScrollFades();
    });
  }

  updateScrollFades() {
    const el = this.scrollEl;
    if (!el) return;
    el.classList.toggle('is-overflow-top', el.scrollTop > 4);
    el.classList.toggle('is-overflow-bottom', el.scrollTop + el.clientHeight < el.scrollHeight - 4);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.renderSections(parsedState.sections);

    if (this.header) this.header.reveal();
    this.open();
  }

  renderSections(sections) {
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
    });

    // Doporučené produkty žijí ve stejné sekci, ale ukazují se v samostatné
    // kartě pod hlavní — když pro přidaný produkt žádné nejsou, karta se skryje.
    const recosTarget = document.getElementById('cart-notification-recos');
    if (recosTarget) {
      const recosSource = new DOMParser()
        .parseFromString(sections['cart-notification-product'], 'text/html')
        .querySelector(`[id="cart-notification-recos-${this.cartItemKey}"]`);
      const recosHtml = recosSource ? recosSource.innerHTML.trim() : '';
      recosTarget.innerHTML = recosHtml;
      recosTarget.toggleAttribute('hidden', recosHtml === '');
    }

    this.scheduleScrollFades();
  }

  onQuantityClick(evt) {
    const button = evt.target.closest('[data-cart-modal-qty]');
    if (!button || button.disabled || this.quantityPending) return;

    const valueElement = this.notification.querySelector('[data-cart-modal-qty-value]');
    if (!valueElement) return;
    const delta = button.dataset.cartModalQty === 'plus' ? 1 : -1;
    const quantity = Math.max(1, parseInt(valueElement.textContent, 10) + delta);
    this.updateQuantity(quantity);
  }

  updateQuantity(quantity) {
    this.quantityPending = true;
    const stepper = this.notification.querySelector('.cart-modal__qty');
    if (stepper) stepper.classList.add('cart-modal__qty--busy');

    const body = JSON.stringify({
      id: this.cartItemKey,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((state) => {
        if (state.errors) return;
        this.renderSections(state.sections);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-notification', cartData: state });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.quantityPending = false;
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
